export default {
  data() {
    return {
      checkListDetails: null,
    };
  },
  methods: {
    getCheckListDetails: function (id) {
      const params = {
        id,
      };
      this.load.val = true;
      this.$store
        .dispatch('getDetailOfCheckListReportDispatch', params)
        .then(() => {
          if (this.$store.state.checkListModule.successFlag) {
            const data = this.$store.state.checkListModule?.checkListDetails;
            this.checkListDetails = data;

            this.transformCheckListDetails(data);
          } else {
            if (this.$store.state.checkListModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.checkListModule.successFlag) {
                  this.getCheckListDetails(id);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.checkListModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getCheckListDetails(id);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
  },
};
